import { createMuiTheme } from '@material-ui/core/styles'

const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
      lg: 1280,
      xl: 1920
    }
  },
  shape: {
    borderRadius: 0
  },
  shadows: Array(25).fill('none'),
  typography: {
    useNextVariants: true,
    htmlFontSize: 16,
    fontSize: 16,
    fontFamily: ['Arial', '"Helvetica Neue"', 'sans-serif'].join(','),
    h1: {
      fontFamily: ['Damm Black', 'Arial'],
      fontSize: 56,
      marginBottom: 16
    },
    h2: {
      fontFamily: ['Damm Black', 'Arial'],
      fontSize: 56
    },
    h3: {
      fontFamily: ['Damm Black', 'Arial'],
      fontSize: 40
    },
    h4: {
      fontFamily: ['Damm Black', 'Arial'],
      fontSize: 24,
      marginBottom: 8
    },
    h5: {
      fontFamily: ['Damm Black', 'Arial'],
      fontSize: 16
    },
    h6: {
      fontFamily: ['Damm Black', 'Arial']
    },
    button: {
      fontWeight: 'bold',
      textTransform: 'capitalize'
    }
  },
  overrides: {
    MuiTabs: {
      indicator: {
        height: 0
      }
    },
    MuiTab: {
      root: {
        fontFamily: 'Damm Black',
        border: '1px solid #000',
        fontWeight: 'normal',
        marginRight: 8
      },
      textColorInherit: {
        opacity: 1
      },
      label: {
        fontSize: '22px'
      },
      selected: {
        color: '#44db5f'
      }
    },
    MuiOutlinedInput: {
      root: {
        '&$focused $notchedOutline': {
          borderColor: '#44db5f'
        },
        '&$error $notchedOutline': {
          borderColor: '#f44336'
        }
      },
      notchedOutline: {
        borderColor: '#9b9b9b'
      },
      adornedEnd: {
        paddingRight: 0
      },
      input: {
        padding: 14
      }
    },
    MuiCheckbox: {
      root: {
        color: '#9b9b9b'
      },
      colorSecondary: {
        '&$checked': {
          color: '#44db5f'
        }
      }
    },
    MuiExpansionPanel: {
      root: {
        '&:before': {
          backgroundColor: '#ffffff'
        }
      }
    },
    MuiExpansionPanelDetails: {
      root: {
        padding: '0 1.2rem 1.4rem'
      }
    },
    MuiExpansionPanelSummary: {
      root: {
        padding: '0 8px'
      },
      content: {
        '& > :last-child': {
          paddingRight: 0
        }
      },
      expandIcon: {
        right: '0.1rem',
        color: '#000000'
      }
    },
    MuiSwitch: {
      switchBase: {
        color: '#EB0505'
      }
    },
    MuiMenuItem: {
      root: {
        fontSize: '1rem',
        border: '1px solid black',
        marginTop: '-1px'
      }
    },
    MuiRadio: {
      colorSecondary: {
        '&$checked': {
          color: '#44db5f'
        }
      }
    },
    MuiToolbar: {
      dense: {
        minHeight: '60px'
      }
    },
    MuiInputBase: {
      root: {
        fontSize: 16,
        color: '#4b4b4b'
      }
    },
    MuiInputLabel: {
      root: {
        fontSize: 16,
        color: '#4b4b4b'
      },
      outlined: {
        transform: 'translate(14px, 16px) scale(1)'
      }
    },
    MuiSelect: {
      icon: {
        right: 8
      }
    }
  },
  palette: {
    primary: {
      main: '#44db5f',
      contrastText: '#fff'
    },
    secondary: {
      main: '#EB0505',
      contrastText: '#fff'
    },
    text: {
      primary: '#000000'
    }
  },
  props: {
    MuiButtonBase: {
      disableRipple: true
    }
  }
})

export default theme
